import { useState } from 'react';
import { useIframeSdk } from '@whop/react';
import { Button, Text } from 'frosted-ui';
import { Sparkle16 } from '@frosted-ui/icons';
import { api } from '../../services/api';
import { upgradeButtonLabel } from './plan';

interface UpgradeButtonProps {
  companyId: string;
  trialAvailable?: boolean;
  onSuccess?: () => void;
}

export default function UpgradeButton({ companyId, trialAvailable, onSuccess }: UpgradeButtonProps) {
  const iframeSdk = useIframeSdk();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleUpgrade() {
    setIsLoading(true);
    setError(null);

    try {
      const checkoutConfig = await api.createProCheckout(companyId);

      const result = await iframeSdk.inAppPurchase({
        planId: checkoutConfig.planId,
        id: checkoutConfig.checkoutConfigurationId,
      });

      if (result.status === 'ok') {
        console.log('Payment processing...');

        if (onSuccess) {
          onSuccess();
        }
      } else {
        console.log('Payment canceled or failed:', result);
        setError('Payment was canceled or failed. Please try again.');
      }
    } catch (err) {
      console.error('Failed to create checkout:', err);
      setError((err as Error).message || "Couldn't open checkout. Try again.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <Button
        variant="solid"
        size="3"
        onClick={handleUpgrade}
        disabled={isLoading}
        loading={isLoading}
      >
        <Sparkle16 />
        {isLoading ? 'Processing...' : upgradeButtonLabel(trialAvailable)}
      </Button>
      {error && (
        <Text size="2" color="red" style={{ display: 'block', marginTop: 'var(--space-2)' }}>
          {error}
        </Text>
      )}
    </div>
  );
}
